import { formatAmount } from '@/util/helpers'
import planPeriodicities from '@/util/planPeriodicities'
import Pagination from '@/util/pagination'

export default function () {
  return {
    formatAmount,
    planPeriodicities,
    plans: [],
    filters: {
      name: '',
    },
    pagination: new Pagination(),
  }
}
